module.exports = __webpack_public_path__ + "img/2.ff4d46d6.png";